
import axios from 'axios'

let baseUrl = process.env.VUE_APP_API_BASE_URL

export class DocumentAPI {
  static fetchDocumentTypes (incidentTypeId) {
    return axios.get(baseUrl + '/api/v1/document/types/' + incidentTypeId)
  }

  static fetchDocumentTypesV2 (payload) {
    return axios.get(baseUrl + '/api/v1/document/types/' + payload.incidentTypeId + '/' + payload.insuranceLineId)
  }
  
  static uploadDocuments (entityReference, entitTypeId, fileTypeId, formData) {
    return axios.post(baseUrl + '/api/v1/document/upload/' + entityReference + '/' + entitTypeId + '/files/' + fileTypeId + '/', formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
  }
}
